import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';

function App() {
  const editorRef = useRef(null);
  const outputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [language, setLanguage] = useState('javascript'); // Default language

  useEffect(() => {
    const editor = monaco.editor.create(editorRef.current, {
      theme: 'vs-dark',
      language: language,
    });

    window.addEventListener('resize', () => {
      editor.layout();
    });

    return () => {
      editor.dispose();
    };
  }, [language]);

// Inside the handleButtonClick function
// Inside the handleButtonClick function
const handleButtonClick = async (action, messageWhileLoading) => {
  setLoading(true);
  setLoadingMessage(messageWhileLoading);

  try {
    const editor = monaco.editor.getModels()[0]; // Get the editor instance
    const code = editor.getValue(); // Get the code from the editor

    let conversionTarget = null; // Initialize conversionTarget

    // Check if the action is "ConvertCode" and set the conversionTarget based on the selected language
    if (action === 'ConvertCode') {
      conversionTarget = language.toLowerCase(); // Use the selected language from the dropdown
    }

    // Update the content directly in the outputRef
    outputRef.current.textContent = messageWhileLoading;

    const response = await fetch('https://weak-erin-boa-coat.cyclic.app/run', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        codeInput: code,
        userRequest: action,
        conversionTarget, // Include the conversionTarget
      }),
    });

    if (response.ok) {
      const data = await response.json();
      console.log(data);

      // Check if data.processedCode is defined
      if (data.processedCode !== undefined) {
        // Update the content directly in the outputRef
        outputRef.current.textContent = data.processedCode;
      } else {
        // Update the content directly in the outputRef
        outputRef.current.textContent = 'Error: No processedCode found in the response.';
      }
    } else {
      // Update the content directly in the outputRef
      outputRef.current.textContent = 'Error: Unable to process your request.';
    }
  } catch (error) {
    // Update the content directly in the outputRef
    outputRef.current.textContent = `Error: ${error.message}`;
  } finally {
    setLoading(false);
    setLoadingMessage('');
  }
};

return (
  <div className="App">
    <h1 className="centered-heading">CODE EDITOR</h1>

    <div className="container">
      <div className="dropdown-container">
        <select
          className="dropdown"
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option value="javascript">JavaScript</option>
          <option value="java">Java</option>
          <option value="php">PHP</option>
          <option value="python">Python</option>
        </select>

        <button
          className="button"
          onClick={() => handleButtonClick('DebugCode', 'Debugging...')}
          disabled={loading}
        >
          Debug
        </button>
        <button
          className="button"
          onClick={() => handleButtonClick('CheckQuality', 'Checking Quality...')}
          disabled={loading}
        >
          Quality
        </button>
        <button
          className="button"
          onClick={() => handleButtonClick('ConvertCode', 'Converting...')}
          disabled={loading}
        >
          Convert
        </button>

        <button
          className="button"
          onClick={() => handleButtonClick('GenerateOutput', 'Running...')}
          disabled={loading}
        >
          Run
        </button>
      </div>

      <div className="editor-container">
        <div className="code-editor" ref={editorRef}></div>
        <div className="output-container" ref={outputRef}>
          Generated Output:
        </div>
      </div>
    </div>
  </div>
);

}

export default App;